define(function(require, exports, module) {

    var $ = require('j');
    var user = require('user');
    var storage = require('util/storage.util');
    var AithManagerBase = require('managers/auth.manager');

    var AuthManager = AithManagerBase.extend({
        login: function(options) {
            var loginState = $.Deferred();

            if (!window.Playtech.API?.auth?.login) {
                loginState.reject();

                return loginState.promise();
            }

            var userName = user.get('userName');
            var password = user.get('password');
            var rememberMeLogin = user.get('rememberMeLogin');
            var fitToPlay = user.get('fitToPlay');
            var afterRegisterLogin = user.get('afterRegisterLogin');
            var loginMode = user.get('loginMode');

            storage.session.removeItem('fitToPlay');

            if (typeof fitToPlay === 'boolean') {
                storage.session.setItem('fitToPlay', fitToPlay);
            }

            const handleSuccess = (response) => {
                user.unset('password');
                loginState.resolve(response);
                options.success(response.data);
            };

            const handleError = (error) => {
                loginState.reject(error);
                options.error(error);
            };

            window.Playtech.API.auth.login(userName, password, rememberMeLogin, afterRegisterLogin, loginMode)
                .then(handleSuccess)
                .catch(handleError);

            return loginState.promise();
        },
    });

    module.exports = AuthManager;
});
